import React, { ReactNode, useEffect, useState } from 'react';

interface DialogResetProps {
  children: ReactNode;
  resetOn: boolean;
}

/**
 * Wraps children with a `key` that changes whenever `resetOn` transitions to
 * `true`, causing React to unmount and remount the subtree. Useful for fully
 * resetting dialog/sidebar state without manually managing keys.
 */
export const DialogReset = ({ children, resetOn }: DialogResetProps) => {
  const [resetKey, setResetKey] = useState(0);

  useEffect(() => {
    if (resetOn) {
      setResetKey(k => k + 1);
    }
  }, [resetOn]);

  return <React.Fragment key={resetKey}>{children}</React.Fragment>;
};
